export default {
  title: "Issues",
  subtitle: "Issue Overview",
  subtitle_issue: "<span class='text-info'>Issue </span> {issue}",
  label_item: "Item",
  label_location: "Location",
  label_issue: "Issue",
  label_designation: "Designation",
  label_details: "Details",
  label_work_domain: "Work domain",
  label_issue_description: "Issue description",
  separator_correction_info: "Correction Information",
  separator_original_issue: "Original Issue",
  label_corrective_action: "Corrective Action",
  label_time_requirement: "Time requirements",
  label_material_requirement: "Material requirements",
  label_additional_requirement: "Additional requirements",
  isolation: "Isolation",
  shutdown: "Shutdown",
}
